/*
 * @Author:
 * @LastEditTime: 2022-06-15 15:21:41
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinBackgroundTask = {
  async apiBackgroundTask(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'retry':
        ;[err, res] = await To(
          wizStandardInstance.put(`/api/std/TaskJob/${arg.params.id}`, arg.params)
        )
        break
      case 'stop':
        ;[err, res] = await To(
          wizStandardInstance.put(`/api/std/TaskJob/${arg.params.id}`, arg.params)
        )
        break
      case 'batch':
        ;[err, res] = await To(wizStandardInstance.put('/api/std/TaskJob/many', arg.params))
        break
      case 'type':
        ;[err, res] = await To(wizStandardInstance.get('/api/std/TaskJob/task-job-state'))
        break
      case 'view':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/std/Document/single-file/${arg.params}`))
        )
        break
      case 'delete':
        ;[err, res] = await To(
          wizStandardInstance.delete('/api/std/TaskJob/many', { data: arg.params })
        )
        break
      case 'jobType':
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/std/TaskInfo?${qs.stringify(arg.params)}`))
        )
        break
      default:
        const listObj = {
          SkipCount: 1,
          MaxResultCount: 10,
          Sorting: '',
          Title: ' ',
          JobType: '',
          JobState: '',
          CreateStartTime: '',
          CreateEndTime: '',
          ModifyStartTime: '',
          ModifyEndTime: '',
          standardId: '',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/std/TaskJob?${qs.stringify(arg.params)}`)
        )
    }
    return Callback.globalCB(err, res)
  },
}

export default {
  methods: ApiMixinBackgroundTask,
}
